//TODO : Refactor after ai
import type { HTMLAttributes } from "react";
import type { ToneColor } from "../types";
import { toneOf } from "../primitives";

export interface CountBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  count?: number;
  max?: number;
  color?: ToneColor;
  variant?: "filled" | "light";
}

/** Zähler-Pille für Navigationseinträge und Reiter. */
export function CountBadge({
  count = 0,
  max = 99,
  color = "brand",
  variant = "filled",
  className = "",
  ...rest
}: CountBadgeProps) {
  const t = toneOf(color);
  const style =
    variant === "filled"
      ? { background: t.solid, color: "#fff" }
      : { background: t.bg, color: t.fg };
  return (
    <span className={`bui-count ${className}`} style={style} {...rest}>
      {count > max ? `${max}+` : count}
    </span>
  );
}
